import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBar from '../SearchBar';
import './Header.css';

const Header = ({ setSupertype, setType, resetListings }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 600);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleLogoClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (location.pathname !== '/') {
            navigate('/');
        } else {
            // Reset filters and refresh listings on homepage
            if (setSupertype) setSupertype('');
            if (setType) setType('');
            if (resetListings) resetListings();
        }
    };

    const handleSupertypeClick = (supertype) => {
        setMobileMenuOpen(false); // Close mobile menu
        navigate(`/${supertype.toLowerCase()}`);
    };

    const handleHomeClick = () => {
        setMobileMenuOpen(false);
        navigate('/');
    };

    return (
        <header className="header">
            <a href="/" className="logo" onClick={handleLogoClick}>
                {isMobile ? <span className="mobile-logo">G</span> : <span className="full-logo">Gradies</span>}
            </a>
            
            {/* Hide SearchBar on Homepage */}
            {location.pathname !== '/' && <SearchBar />}
            
            {!isMobile && (
                <nav className="nav">
                    <button onClick={() => handleSupertypeClick('Pokemon')}>Pokémon</button>
                    <button onClick={() => handleSupertypeClick('Trainer')}>Trainers</button>
                    <button onClick={() => handleSupertypeClick('Energy')}>Energy</button>
                    <button onClick={() => handleSupertypeClick('Promo')}>Promo</button>
                    <button onClick={() => handleSupertypeClick('Sets')}>Sets</button>
                    <a href="/profile"><i className="fa fa-user-circle"></i></a>
                </nav>
            )}
            {isMobile && (
                <button
                    className="hamburger-menu"
                    aria-label="Open menu"
                    onClick={() => setMobileMenuOpen(true)}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>
            )}
            {isMobile && mobileMenuOpen && (
                <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
                    <nav className="mobile-menu" onClick={e => e.stopPropagation()}>
                        <button onClick={handleHomeClick}>Home</button>
                        <button onClick={() => handleSupertypeClick('Pokemon')}>Pokémon</button>
                        <button onClick={() => handleSupertypeClick('Trainer')}>Trainers</button>
                        <button onClick={() => handleSupertypeClick('Energy')}>Energy</button>
                        <button onClick={() => handleSupertypeClick('Promo')}>Promo</button>
                        <button onClick={() => handleSupertypeClick('Sets')}>Sets</button>
                    </nav>
                </div>
            )}
        </header>
    );
};

export default Header;
